import { SmartFilter } from '@Portal/models/smartFilters/SmartFilter';
import { OrderBy } from './OrderBy';

export interface Card {
  idField: string;
  verbatim: string;
  metricValue: number;
  dateTimeField: string;
  programField: string;
  footerFields: { title: string; value?: string }[];
}

export enum VisualType {
  CardCarousel = 'CardCarousel',
  GaugeChart = 'GaugeChart',
  DriverGauges = 'DriverGauges',
  MeasureLeaderboard = 'MeasureLeaderboard',
  MeasureList = 'MeasureList',
  Trends = 'Trends',
  FrontlineTopBanner = 'FrontlineTopBanner',
  FrontlinePrimaryMetric = 'FrontlinePrimaryMetric',
  ProgramDriverGauges = 'ProgramDriverGauges',
  FrontlineProgramBreakdown = 'FrontlineProgramBreakdown',
  ProcessFlowFeed = 'ProcessFlowFeed',
  SmartInsights = 'SmartInsights',
  OneValueTile = 'OneValueTile',
  DaysSinceLastResponse = 'DaysSinceLastResponse',
  MeasureTile = 'MeasureTile',
  MetricBreakdownTile = 'MetricBreakdownTile',
  SlicedMetricBreakdownTiles = 'SlicedMetricBreakdownTiles',
  TopNValuesTile = 'TopNValuesTile',
  TopValueByMeasureTile = 'TopValueByMeasureTile',
  BarChart = 'BarChart',
  KeyTopicInsightsChart = 'KeyTopicInsightsChart',
  LineChart = 'LineChart',
  PieChart = 'PieChart',
  DoughnutChart = 'DoughnutChart',
  EmptyChart = 'EmptyChart',
  StackedBarChart = 'StackedBarChart',
  ClusteredBarChart = 'ClusteredBarChart',
  SocialReviewRatings = 'SocialReviewRatings',
  SocialReviewFeed = 'SocialReviewFeed',
  SocialReviewReplies = 'SocialReviewReplies',
  SocialReviewsGenerated = 'SocialReviewsGenerated',
  Favourites = 'Favourites',
  BenchmarkPrograms = 'BenchmarkPrograms',
  ImprovedLikeForLikeReport = 'ImprovedLikeForLikeReport',
  NpsStackedBarWithLine = 'NpsStackedBarWithLine',
  BenchmarkProgramsDemo = 'BenchmarkProgramsDemo',
}

export interface DataSource {
  name: string;
  smartDataModuleId: string;
  defaultOrderBy?: OrderBy;
  smartDataTags: string[];
  smartFilterTags: string[];
  defaultSmartFilters: SmartFilter[];
  favouritesModuleId: string;
  isSocial: boolean;
  dateFilterType: string;
}

export enum DashboardType {
  Frontline = 'Frontline',
  SrgCustomerBoard = 'SrgCustomerBoard',
  CustomerCentreStage = 'CustomerCentreStage',
  Social = 'Social',
  Reporting = 'Reporting',
  Benchmarking = 'Benchmarking',
}

export interface FrontlineDashboardDataSource extends DataSource {
  type: DashboardType.Frontline;
  visualTypes: Record<string, VisualType>;
  filterKeys: Record<string, string>;

  primaryMetricPopupTitle: string;
  driversPopupTitle: string;
  driversPopupSubtitle: string;
  isSocial: false;
}

export interface SrgCustomerBoardDataSource extends DataSource {
  type: DashboardType.SrgCustomerBoard;
  visualTypes: Record<string, VisualType>;
  filterKeys: Record<string, string>;
  isSocial: false;
}

export interface SocialReviewsDashboardDataSource extends DataSource {
  type: DashboardType.Social;
  visualTypes: Record<string, VisualType>;
  isSocial: true;
}

export interface DataVizDataSource extends DataSource {
  friendlyName: string;
  defaultDataSource: boolean;
  isSocial: false;
}

export interface CustomerCentreStageDataSource extends DataSource {
  type: DashboardType.CustomerCentreStage;
  topVisualDateFilter: string;
  bottomVisualsDateFilter: string;
  bottomLayoutDetails: { visual: string; width: number; type: VisualType }[];
  isSocial: false;
}

export interface ReportingDataSource extends DataSource {
  type: DashboardType.Reporting;
  visualTypes: Record<string, VisualType>;
  filterKeys: Record<string, string>;
  isSocial: false;
}

export interface BenchmarkDashboardDataSource extends DataSource {
  type: DashboardType.Benchmarking;
  locationFilterKey: string;
  visualTypes: Record<string, VisualType>;
  filterKeys: Record<string, string>;
  isDemo: boolean;
}
